import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'sonner';

import {
  useCreateCurrencyMutation,
  useGetCurrency,
} from '~shared/api/currency-api';
import { Button } from '~shared/shadcn/ui/button';
import { Form } from '~shared/shadcn/ui/form';
import { Label } from '~shared/shadcn/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~shared/shadcn/ui/select';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

const Components = () => {
  // const stripeMutation = useCreateStripeCredentialsMutation();
  const currencyMutation = useCreateCurrencyMutation();
  // const deleteMutation = useDeleteStripeCredentialsMutation();
  // const { data: studioDetails } = useGetStudioDetails();
  const { data: currencyDetails } = useGetCurrency();
  // const { data: stripeCredentialsData } = useGetStripeCredentials(
  //   studioDetails?._id ?? '',
  // );

  // const stripeForm = useForm({
  //   defaultValues: {
  //     publicKey: '',
  //     secretKey: '',
  //   },
  // });

  const currencyForm = useForm({
    defaultValues: {
      currency: 'USD',
    },
  });

  // Reset form with actual values when editing
  // useEffect(() => {
  //   if (stripeCredentialsData) {
  //     stripeForm.reset({
  //       publicKey: '••••••••••••••••',
  //       secretKey: '••••••••••••••••',
  //     });
  //   } else {
  //     stripeForm.reset({
  //       publicKey: '',
  //       secretKey: '',
  //     });
  //   }
  // }, [stripeCredentialsData]);

  // const onStripeSubmit = async (data: {
  //   publicKey: string;
  //   secretKey: string;
  // }) => {
  //   try {
  //     console.log('studioDetails', studioDetails);
  //     await stripeMutation.mutateAsync({
  //       ...data,
  //       studioId: studioDetails?._id ?? '',
  //     });
  //     toast.success('Stripe integration created successfully');
  //   } catch (error: unknown) {
  //     console.log(error);
  //     toast.error(
  //       String(
  //         (error as { response: { data: { message: string } } }).response.data
  //           .message || 'Failed to create Stripe integration',
  //       ),
  //     );
  //   }
  // };

  const onCurrencySubmit = async (data: { currency: string }) => {
    try {
      await currencyMutation.mutateAsync({
        name: data.currency,
      });
      toast.success('Currency created successfully');
    } catch (error) {
      console.error('Error creating Currency integration:', error);
      toast.error('Error creating Currency integration');
    }
  };

  // const handleDelete = async () => {
  //   if (!studioDetails?._id) return;
  //   await deleteMutation.mutateAsync(studioDetails._id);
  // };

  // const hasExistingKeys = false; // TODO: Replace with actual check for existing keys

  return (
    <div className=''>
      <Link to='/dashboard' className='mb-8 flex items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <span className='text-lg font-semibold'>Back to Dashboard</span>
      </Link>
      <div className='flex justify-around'>
        <div className='w-full max-w-xl space-y-8 rounded-lg border border-border bg-white p-8'>
          {/* <div className='flex justify-center'>
            <img src='/stripe-4.svg' className='h-20' alt='Stripe logo' />
          </div>
          <h2 className='text-center text-2xl font-bold text-gray-800'>
            Configure Stripe Integration
          </h2>
          <p className='text-center text-[#6772E5]'>
            Please connect your Stripe account through Enrollio CRM first, then
            enter the Stripe API keys.
          </p>
          <p className='text-center text-gray-600'>
            Enter your Stripe API keys to enable payment processing.
          </p> */}

          {/* <Form {...stripeForm}>
            <form
              onSubmit={stripeForm.handleSubmit(onStripeSubmit)}
              className='space-y-4'
            >
              <FormField
                control={stripeForm.control}
                name='publicKey'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Public Key</FormLabel>
                    <FormControl>
                      <Input placeholder='pk_test_...' {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormField
                control={stripeForm.control}
                name='secretKey'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Secret Key</FormLabel>
                    <FormControl>
                      <Input
                        type='password'
                        placeholder='sk_test_...'
                        {...field}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              {stripeCredentialsData && (
                <Button
                  type='button'
                  variant='destructive'
                  onClick={handleDelete}
                  className='w-full'
                  disabled={deleteMutation.isPending}
                >
                  {deleteMutation.isPending ? (
                    <>
                      <Loader2 className='mr-2 size-4 animate-spin' />
                      Deleting Keys
                    </>
                  ) : (
                    'Delete Keys'
                  )}
                </Button>
              )}

              <Button
                type='submit'
                className='w-full bg-[#6772E5] text-white hover:bg-[#5469D4]'
                disabled={stripeCredentialsData}
              >
                {stripeMutation.isPending ? (
                  <>
                    <Loader2 className='mr-2 size-4 animate-spin' />
                    Saving Keys
                  </>
                ) : (
                  'Save Keys'
                )}
              </Button>
            </form>
          </Form> */}
          <Form {...currencyForm}>
            <form
              onSubmit={currencyForm.handleSubmit(onCurrencySubmit)}
              className='space-y-4'
            >
              <div className='space-y-4'>
                <h2 className='text-xl font-semibold'>Currency Selection</h2>
                <div className='space-y-2'>
                  <Label>
                    Select the currency you want to use for your studio
                  </Label>
                  <Controller
                    control={currencyForm.control}
                    name='currency'
                    render={({ field }) => (
                      <Select
                        value={currencyDetails?.name ?? field.value}
                        onValueChange={field.onChange}
                        disabled={currencyDetails ? true : false}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder='Select Currency' />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value='USD'>
                            United States Dollar ($)
                          </SelectItem>
                          <SelectItem value='CAD'>
                            Canadian Dollar (C$)
                          </SelectItem>
                          <SelectItem value='AUD'>
                            Australian Dollar (A$)
                          </SelectItem>
                          <SelectItem value='NZD'>
                            New Zealand Dollar (NZ$)
                          </SelectItem>
                          <SelectItem value='GBP'>British Pound (£)</SelectItem>
                        </SelectContent>
                      </Select>
                    )}
                  />
                </div>
              </div>

              <Button
                type='submit'
                className='w-full'
                disabled={currencyDetails ? true : false}
              >
                Select Currency
              </Button>
            </form>
          </Form>
        </div>
        {/* <Card
          className='max-w-4xl'
          style={{
            maxHeight: '850px',
          }}
        >
          <CardContent className='p-0'>
            <video
              src={
                'https://storage.googleapis.com/enrolliocsv-example/tutorial%20video%20one.mp4'
              }
              controls
              className='h-auto w-full'
            >
              Your browser does not support the video tag.
            </video>
          </CardContent>
          <CardHeader>
            <CardTitle className='line-clamp-2 text-xl font-bold'>
              Setting Up Stripe Integration in Enrollio
            </CardTitle>
            <CardDescription className='space-y-2 text-base text-muted-foreground'>
              Set up Stripe for your Studio Portal. Watch our detailed setup
              video to get started. For any assistance or additional support,
              reach out to us at support@enrollio.ai.
              <br />
              <br />
              <b>Step 1 - Connect your Enrollio CRM to Stripe.</b>
              <br />
              <br />
              <b>Step 2 - Enter your Stripe API keys.</b>
              <br />
              <br />
              <b>Step 3 - Choose your local currency.</b>
              <br />
            </CardDescription>
          </CardHeader>
        </Card> */}
      </div>
    </div>
  );
};

export const Route = createFileRoute('/_auth/_layout/integrations')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: Components,
});
